var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CrossOutedFilter.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const CrossOutedFilter = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M17.0731 18.2591C16.7452 18.587 16.2135 18.587 15.8856 18.2591L1.73974 4.11328C1.41183 3.78536 1.41183 3.2537 1.73975 2.92578C2.06767 2.59786 2.59933 2.59786 2.92725 2.92578L17.0731 17.0716C17.401 17.3995 17.401 17.9312 17.0731 18.2591ZM3.3335 6.66536C2.87326 6.66536 2.50016 6.29227 2.50016 5.83203C2.50016 5.37179 2.87326 4.9987 3.3335 4.9987H4.29183V6.66536H3.3335ZM5.8335 10.832C5.37326 10.832 5.00016 10.4589 5.00016 9.9987C5.00016 9.53846 5.37326 9.16536 5.8335 9.16536H8.4585V10.832H5.8335ZM9.021 6.66536L7.35433 4.9987H16.6668C17.1271 4.9987 17.5002 5.37179 17.5002 5.83203C17.5002 6.29227 17.1271 6.66536 16.6668 6.66536H9.021ZM9.16683 14.9987C8.70659 14.9987 8.3335 14.6256 8.3335 14.1654C8.3335 13.7051 8.70659 13.332 9.16683 13.332H10.8335C11.2937 13.332 11.6668 13.7051 11.6668 14.1654C11.6668 14.6256 11.2937 14.9987 10.8335 14.9987H9.16683ZM13.1877 10.832L11.521 9.16536H14.1668C14.6271 9.16536 15.0002 9.53846 15.0002 9.9987C15.0002 10.4589 14.6271 10.832 14.1668 10.832H13.1877Z",
    fill: color
  })
});